import icons from './iconify-icons-data';

const defaultIcon = {
  left: 0,
  top: 0,
  width: 16,
  height: 16,
};

function renderIcon(element) {
  const iconName = element.getAttribute('icon');
  const icon = icons[iconName];

  if (!icon) {
    // The set is local (iconify-icons-data.js), not the Iconify API, so a name
    // that is not in it renders nothing at all. Silence made that look like a
    // styling problem; say so instead.
    if (typeof console !== 'undefined' && console.warn) {
      console.warn(`[iconify-local] unknown icon "${iconName}" - add it to resources/js/iconify-icons-data.js`);
    }

    element.replaceChildren();
    return;
  }

  const left = icon.left ?? defaultIcon.left;
  const top = icon.top ?? defaultIcon.top;
  const width = icon.width ?? defaultIcon.width;
  const height = icon.height ?? defaultIcon.height;
  const renderedWidth = element.getAttribute('width') || '1em';
  const renderedHeight = element.getAttribute('height') || element.getAttribute('width') || '1em';

  element.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg"
         viewBox="${left} ${top} ${width} ${height}"
         width="${renderedWidth}"
         height="${renderedHeight}"
         aria-hidden="true"
         focusable="false">
      ${icon.body}
    </svg>
  `;
}

if (typeof window !== 'undefined' && !window.customElements.get('iconify-icon')) {
  window.customElements.define('iconify-icon', class extends HTMLElement {
    static get observedAttributes() {
      return ['icon', 'width', 'height'];
    }

    connectedCallback() {
      renderIcon(this);
    }

    attributeChangedCallback() {
      renderIcon(this);
    }
  });
}
